<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Update Emission Area Type</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <fieldset>
        <form [formGroup]="addressForm" #f="ngForm">
            <div class="row">
                <div class="col-sm-9 col-md-6 mvd_form-group">
                    <label for="emissionAreaTypeId">Emission Area Type</label>
                    <select class="mvd_form-control" id="emissionAreaTypeId" formControlName="emissionAreaTypeId">
                        <option *ngFor="let t of emissionAreaTypeLookups" [value]="t.id">{{t.displayValue}}</option>
                    </select>
                </div>
            </div>
        </form>
    </fieldset>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [btnType]="'button'" [isDisabled]="!(addressForm.valid && addressForm.dirty)" [isLoading]="inProgress" [btnText]="'Save'" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>